import type en from '../en/rental'
import type { Translation } from '../types'

/** Rental */
const rental: Translation<typeof en> = {
  "rental.title": "Alquiler",
  "rental.subtitle": "Inventario, planificación, eventos y compras",
  "rental.sections": "Secciones del alquiler",
  "rental.tab.planning": "Planificación",
  "rental.tab.events": "Eventos",
  "rental.tab.customers": "Clientes",
  "rental.tab.stock": "Inventario",
  "rental.tab.suppliers": "Proveedores",
  "rental.tab.purchasing": "Compras",
  "rental.search": "Buscar",
  "rental.notes": "Notas",
  "rental.details": "Datos",
  "rental.saveFailed": "No se ha podido guardar",
  "rental.amountInvalid": "Un importe no es un número, como 12,50",
  "rental.percentInvalid": "Un porcentaje es un número de 0 a 100",
  "rental.stock.sections": "Secciones del inventario",
  "rental.stock.articles": "Artículos",
  "rental.stock.items": "Inventario",
  "rental.stock.warehouses": "Almacenes",
  "rental.stock.transfers": "Traslados",
  "rental.stock.categories": "Categorías",
  "rental.article.add": "Añadir artículo",
  "rental.article.edit": "Editar artículo",
  "rental.article.save": "Guardar artículo",
  "rental.article.saved": "Artículo guardado",
  "rental.article.deleted": "Artículo eliminado",
  "rental.article.deleteConfirm": "¿Eliminar el artículo {name}? Un artículo con unidades, existencias o líneas no se puede eliminar: desactívelo en su lugar.",
  "rental.article.empty": "Todavía no hay artículos",
  "rental.article.sku": "Referencia",
  "rental.article.name": "Nombre",
  "rental.article.description": "Descripción",
  "rental.article.category": "Categoría",
  "rental.article.allCategories": "Todas las categorías",
  "rental.article.showInactive": "Mostrar inactivos",
  "rental.article.inactive": "Inactivo",
  "rental.article.active": "Activo (se puede poner en eventos)",
  "rental.article.perItem": "Por unidad (número de serie)",
  "rental.article.bulk": "Cantidad (a granel)",
  "rental.article.dayPrice": "Precio por día",
  "rental.article.weekendPrice": "Precio fin de semana",
  "rental.article.weekPrice": "Precio semana",
  "rental.article.fromDayPrice": "Vacío: a partir del precio por día",
  "rental.article.vatRate": "IVA (%)",
  "rental.article.vatDefault": "Vacío: el tipo predeterminado de la empresa",
  "rental.article.vatDefaultShort": "predeterminado",
  "rental.article.purchasePrice": "Precio de compra",
  "rental.article.externalCode": "Código en el software de facturación",
  "rental.article.prices": "Precios sin IVA",
  "rental.article.stock": "Existencias",
  "rental.article.noStock": "Sin existencias",
  "rental.item.add": "Añadir unidad",
  "rental.item.save": "Guardar unidad",
  "rental.item.saved": "Unidad guardada",
  "rental.item.empty": "No hay unidades",
  "rental.item.serial": "Número de serie",
  "rental.item.mac": "Dirección MAC",
  "rental.item.tag": "Etiqueta",
  "rental.item.tagHint": "La etiqueta NFC o el código QR (opcional por ahora)",
  "rental.item.article": "Artículo",
  "rental.item.warehouse": "Almacén",
  "rental.item.status": "Estado",
  "rental.item.statusOf": "Estado de {name}",
  "rental.item.historyOf": "Historial de {name}",
  "rental.item.allArticles": "Todos los artículos",
  "rental.item.allWarehouses": "Todos los almacenes",
  "rental.item.allStatuses": "Todos los estados",
  "rental.bulk.title": "Cantidad por almacén",
  "rental.bulk.count": "Contar",
  "rental.bulk.countOf": "Contar {name}",
  "rental.bulk.counted": "Contado",
  "rental.bulk.note": "Por qué (opcional)",
  "rental.bulk.save": "Guardar recuento",
  "rental.bulk.saved": "Recuento guardado",
  "rental.bulk.quantity": "Cantidad",
  "rental.bulk.packed": "De ello en maletas",
  "rental.warehouse.add": "Añadir almacén",
  "rental.warehouse.edit": "Editar almacén",
  "rental.warehouse.editOf": "Editar {name}",
  "rental.warehouse.save": "Guardar almacén",
  "rental.warehouse.saved": "Almacén guardado",
  "rental.warehouse.deleted": "Almacén eliminado",
  "rental.warehouse.deleteOf": "Eliminar {name}",
  "rental.warehouse.deleteConfirm": "¿Eliminar el almacén {name}? Solo se puede eliminar un almacén vacío y sin eventos.",
  "rental.warehouse.empty": "Todavía no hay almacenes: añada el primero",
  "rental.warehouse.name": "Nombre",
  "rental.warehouse.address": "Dirección",
  "rental.warehouse.default": "Almacén principal",
  "rental.warehouse.makeDefault": "Hacer almacén principal",
  "rental.warehouse.makeDefaultOf": "Hacer de {name} el almacén principal",
  "rental.transfer.add": "Nuevo traslado",
  "rental.transfer.save": "Trasladar",
  "rental.transfer.done": "Trasladado",
  "rental.transfer.empty": "Todavía no hay traslados",
  "rental.transfer.from": "Desde",
  "rental.transfer.to": "Hacia",
  "rental.transfer.when": "Cuándo",
  "rental.transfer.fromTo": "Desde → hacia",
  "rental.transfer.what": "Qué",
  "rental.transfer.by": "Por",
  "rental.transfer.bulk": "Cantidades",
  "rental.transfer.noItems": "No hay unidades sueltas ni piezas en este almacén (lo que hay en una pieza se traslada con ella)",
  "rental.transfer.summary": "Unidades y piezas: {items} · a granel: {bulk}",
  "rental.category.add": "Añadir categoría",
  "rental.category.name": "Nombre de la categoría",
  "rental.category.saved": "Categoría guardada",
  "rental.category.deleted": "Categoría eliminada",
  "rental.category.renameOf": "Renombrar {name}",
  "rental.category.deleteOf": "Eliminar {name}",
  "rental.category.deleteConfirm": "¿Eliminar la categoría {name}? Sus artículos se quedan, sin categoría.",
  "rental.category.empty": "Todavía no hay categorías",
  "rental.history.title": "Historial",
  "rental.history.empty": "Todavía no ha pasado nada",
  "rental.history.quantity": { one: "{count} unidad", other: "{count} unidades" },
  "rental.history.item.status": "Estado cambiado",
  "rental.history.bulk.count": "Contado",
  "rental.history.transfer": "Traslado",
  "rental.history.receipt": "Recibido",
  "rental.history.subrental.return": "Devuelto al proveedor",
  "rental.status.IN_STOCK": "En inventario",
  "rental.status.AT_EVENT": "En un evento",
  "rental.status.IN_REPAIR": "En reparación",
  "rental.status.LOST": "Perdido",
  "rental.status.RETIRED": "Retirado",
  "rental.status.RETURNED": "Devuelto al proveedor",
  "rental.status.REQUESTED": "Solicitado",
  "rental.status.RESERVED": "Reservado",
  "rental.status.CONFIRMED": "Confirmado",
  "rental.status.CLOSED": "Cerrado",
  "rental.status.CANCELLED": "Cancelado",
  "rental.status.DRAFT": "Borrador",
  "rental.status.AWAITING_APPROVAL": "Pendiente de aprobación",
  "rental.status.SENT": "Enviado",
  "rental.status.PARTLY_RECEIVED": "Recibido en parte",
  "rental.status.RECEIVED": "Recibido",
  "rental.customer.add": "Añadir cliente",
  "rental.customer.edit": "Editar cliente",
  "rental.customer.save": "Guardar cliente",
  "rental.customer.saved": "Cliente guardado",
  "rental.customer.deleted": "Cliente eliminado",
  "rental.customer.deleteConfirm": "¿Eliminar el cliente {name}? Un cliente con eventos no se puede eliminar.",
  "rental.customer.empty": "Todavía no hay clientes",
  "rental.customer.name": "Nombre",
  "rental.customer.contact": "Persona de contacto",
  "rental.customer.email": "Correo electrónico",
  "rental.customer.phone": "Teléfono",
  "rental.customer.address": "Dirección",
  "rental.customer.vatNumber": "NIF/IVA",
  "rental.customer.externalRef": "Código en el software de facturación",
  "rental.customer.noEvents": "Todavía no hay eventos",
  "rental.supplier.add": "Añadir proveedor",
  "rental.supplier.edit": "Editar proveedor",
  "rental.supplier.save": "Guardar proveedor",
  "rental.supplier.saved": "Proveedor guardado",
  "rental.supplier.deleted": "Proveedor eliminado",
  "rental.supplier.deleteConfirm": "¿Eliminar el proveedor {name}? Un proveedor con pedidos no se puede eliminar.",
  "rental.supplier.empty": "Todavía no hay proveedores",
  "rental.supplier.name": "Nombre",
  "rental.supplier.contact": "Persona de contacto",
  "rental.supplier.email": "Correo electrónico",
  "rental.supplier.phone": "Teléfono",
  "rental.supplier.address": "Dirección",
  "rental.supplier.vatNumber": "NIF/IVA",
  "rental.supplier.language": "Idioma",
  "rental.supplier.languageHint": "Sus cartas de pedido y correos están en este idioma",
  "rental.supplier.orders": "Pedidos y solicitudes",
  "rental.supplier.noOrders": "Todavía no hay pedidos ni solicitudes",
  "rental.settings.prices": "Precios",
  "rental.settings.method": "Cómo se calculan los precios",
  "rental.settings.method.STAFFEL": "Un precio por día con escala",
  "rental.settings.method.STAFFEL.hint": "El precio por día por el factor del número de días",
  "rental.settings.method.FIXED": "Precios fijos por día, fin de semana y semana",
  "rental.settings.method.FIXED.hint": "Dentro de un fin de semana (viernes 12:00 a lunes 12:00) el precio de fin de semana; si no, semanas y días, los días nunca más que una semana",
  "rental.settings.staffel": "La escala",
  "rental.settings.from": "Desde",
  "rental.settings.days": "Días",
  "rental.settings.daysTimes": "días:",
  "rental.settings.factor": "Factor",
  "rental.settings.dayPrice": "× el precio por día",
  "rental.settings.addRow": "Añadir fila",
  "rental.settings.removeRow": "Quitar esta fila",
  "rental.settings.extraDay": "Cada día tras la última fila añade (× el precio por día)",
  "rental.settings.staffelInvalid": "Cada fila de la escala necesita días enteros y un factor como 1,5",
  "rental.settings.vat": "Tipo de IVA predeterminado (%)",
  "rental.settings.currency": "Moneda",
  "rental.settings.fourEyes": "Otra persona debe aprobar",
  "rental.settings.fourEyesHint": "Quien crea o solicita un pedido de compra o de subalquiler no puede aprobarlo",
  "rental.settings.letters": "En las cartas a proveedores",
  "rental.settings.lettersHint": "El logotipo de la empresa encabeza la carta si lo tiene",
  "rental.settings.letterName": "Razón social",
  "rental.settings.letterAddress": "Dirección",
  "rental.settings.letterVat": "NIF/IVA",
  "rental.settings.letterCoc": "Número de registro mercantil",
  "rental.settings.letterEmail": "Correo electrónico",
  "rental.settings.letterPhone": "Teléfono",
  "rental.settings.save": "Guardar ajustes de alquiler",
  "rental.settings.saved": "Ajustes de alquiler guardados",
  "rental.event.add": "Nuevo evento",
  "rental.event.edit": "Editar evento",
  "rental.event.save": "Guardar evento",
  "rental.event.saved": "Evento guardado",
  "rental.event.empty": "Todavía no hay eventos",
  "rental.event.needed": "Elija el cliente y el periodo de alquiler",
  "rental.event.name": "Evento",
  "rental.event.customer": "Cliente",
  "rental.event.rentalStart": "Inicio del alquiler",
  "rental.event.rentalEnd": "Fin del alquiler",
  "rental.event.rentalPeriod": "Periodo de alquiler",
  "rental.event.materialPeriod": "Salida y regreso del material",
  "rental.event.materialOut": "Salida del material",
  "rental.event.materialBack": "Regreso del material",
  "rental.event.materialApart": "El material sale antes o vuelve después que el alquiler",
  "rental.event.warehouse": "Almacén principal",
  "rental.event.homeWarehouse": "El almacén principal de la empresa",
  "rental.event.site": "Sitio",
  "rental.event.externalRef": "Número de presupuesto",
  "rental.event.total": "Total",
  "rental.event.short": "Falta",
  "rental.event.reserve": "Reservar",
  "rental.event.confirm": "Confirmar",
  "rental.event.close": "Cerrar",
  "rental.event.cancel": "Cancelar evento",
  "rental.event.reopen": "Reabrir",
  "rental.event.cancelConfirm": "¿Cancelar el evento {name}? Ya no retendrá material.",
  "rental.event.statusSaved": "Ahora: {status}",
  "rental.line.title": "Líneas",
  "rental.line.empty": "Todavía no hay líneas: añada un artículo abajo",
  "rental.line.add": "Añadir línea",
  "rental.line.save": "Guardar línea",
  "rental.line.saved": "Línea guardada",
  "rental.line.deleted": "Línea eliminada",
  "rental.line.editOf": "Editar la línea de {name}",
  "rental.line.deleteOf": "Eliminar la línea de {name}",
  "rental.line.deleteConfirm": "¿Eliminar la línea de {name}?",
  "rental.line.quantity": "Cantidad",
  "rental.line.unitPrice": "Precio unitario",
  "rental.line.calculated": "calculado {price}",
  "rental.line.customPrice": "Precio unitario propio",
  "rental.line.customHint": "Vacío: el calculado {price}",
  "rental.line.availability": "Libre y faltante",
  "rental.line.shortBy": "Faltan {count}",
  "rental.line.free": "Libre: {free} (si los presupuestos pendientes caen: {fall})",
  "rental.line.subrented": "{count} subalquilado(s)",
  "rental.line.expected": "{count} esperado(s)",
  "rental.line.requested": "{count} solicitado(s), aún sin confirmar",
  "rental.line.transferFrom": "Trasladar desde {name}",
  "rental.discount.title": "Descuento",
  "rental.discount.type": "Tipo",
  "rental.discount.none": "Ninguno",
  "rental.discount.percent": "Un porcentaje",
  "rental.discount.amount": "Un importe",
  "rental.discount.value": "Importe",
  "rental.discount.save": "Guardar descuento",
  "rental.discount.saved": "Descuento guardado",
  "rental.totals.title": "Totales",
  "rental.totals.subtotal": "Subtotal",
  "rental.totals.discount": "Descuento",
  "rental.totals.vat": "IVA {rate}",
  "rental.totals.total": "Total",
  "rental.planning.table": "Planificación",
  "rental.planning.span": "Periodo",
  "rental.planning.day": "Día",
  "rental.planning.week": "Semana",
  "rental.planning.month": "Mes",
  "rental.planning.date": "Fecha",
  "rental.planning.previous": "Anterior",
  "rental.planning.next": "Siguiente",
  "rental.planning.today": "Hoy",
  "rental.planning.cell": "{article}, {day}: {free} libre(s), {held} retenido(s)",
  "rental.planning.cellShort": "— faltan {count}",
  "rental.planning.shortEvents": "Eventos con faltantes",
  "rental.planning.noneShort": "No falta nada en este periodo",
  "rental.planning.owned": "Propio",
  "rental.planning.subrented": "Subalquilado",
  "rental.planning.expected": "Esperado",
  "rental.planning.from": "Desde",
  "rental.planning.held": "Retenido",
  "rental.planning.free": "Libre",
  "rental.order.purchaseOrders": "Pedidos de compra",
  "rental.order.subRentals": "Subalquileres",
  "rental.order.purchaseOrder": "Pedido de compra",
  "rental.order.subRental": "Subalquiler",
  "rental.order.newPurchase": "Nuevo pedido de compra",
  "rental.order.newSubRental": "Nuevo subalquiler",
  "rental.order.savePurchase": "Guardar pedido de compra",
  "rental.order.saveSubRental": "Guardar subalquiler",
  "rental.order.purchaseSaved": "Pedido de compra guardado",
  "rental.order.subRentalSaved": "Subalquiler guardado",
  "rental.order.edit": "Editar {number}",
  "rental.order.editShort": "Editar",
  "rental.order.deleted": "Eliminado",
  "rental.order.deleteConfirm": "¿Eliminar el borrador {number}?",
  "rental.order.empty": "Todavía no hay nada",
  "rental.order.number": "Número",
  "rental.order.supplier": "Proveedor",
  "rental.order.warehouse": "Almacén de recepción",
  "rental.order.expected": "Entrega prevista",
  "rental.order.window": "Periodo de alquiler",
  "rental.order.from": "Desde",
  "rental.order.to": "Hasta",
  "rental.order.forEvent": "Para el evento",
  "rental.order.notes": "Notas para el proveedor",
  "rental.order.supplierCode": "Referencia del proveedor",
  "rental.order.unitPrice": "Precio unitario",
  "rental.order.unitCost": "Coste por unidad",
  "rental.order.received": "Recibido hasta ahora",
  "rental.order.items": "Unidades registradas",
  "rental.order.madeBy": "Creado por",
  "rental.order.askedBy": "Aprobación solicitada por",
  "rental.order.approvedBy": "Aprobado por",
  "rental.order.sentTo": "Enviado a",
  "rental.order.askApproval": "Solicitar aprobación",
  "rental.order.approve": "Aprobar",
  "rental.order.sendAgain": "Volver a enviar",
  "rental.order.recordConfirmation": "Registrar confirmación",
  "rental.order.registerItems": "Registrar unidades",
  "rental.order.saveItems": "Guardar unidades",
  "rental.order.itemsSaved": "Unidades registradas",
  "rental.order.allRegistered": "Todas registradas",
  "rental.order.close": "Cerrar subalquiler",
  "rental.order.closeConfirm": "¿Cerrar? Sus unidades registradas vuelven al proveedor.",
  "rental.order.receive": "Recibir",
  "rental.order.receiveLine": "{name}: recibidos {received} de {quantity}, ahora",
  "rental.order.serialOf": "Número de serie {n}",
  "rental.order.saveReceipt": "Guardar recepción",
  "rental.order.receiptSaved": "Recepción guardada",
  "rental.order.newExpected": "Nuevo día previsto",
  "rental.order.saveExpected": "Guardar día",
  "rental.order.expectedSaved": "Día previsto guardado",
  "rental.order.cancelOrder": "Cancelar pedido",
  "rental.order.cancelRequest": "Cancelar solicitud",
  "rental.order.cancelConfirm": "¿Cancelar {number}?",
  "rental.order.pdf": "Descargar PDF",
  "rental.order.waiting": "Esperando a alguien que pueda aprobar",
  "rental.order.someoneElse": "Otra persona debe aprobar esto",
  "rental.order.notSent": "Aprobado, no enviado",
  "rental.order.notSentReason": "Aprobado, pero el correo al proveedor no se envió: {reason}",
  "rental.order.done.request-approval": "Enviado para aprobación",
  "rental.order.done.approve": "Aprobado y enviado",
  "rental.order.done.send": "Enviado al proveedor",
  "rental.order.done.cancel": "Cancelado",
  "rental.order.done.confirm": "Confirmación registrada",
  "rental.order.done.close": "Cerrado: sus unidades se devolvieron",
  "rental.order.byHandHint": "Descargue el PDF y envíelo usted mismo al proveedor; después marque el pedido como enviado.",
  "rental.order.markSent": "Marcar como enviado",
  "rental.order.markSentConfirm": "¿Marcar {number} como enviado? Hágalo cuando el proveedor tenga la carta.",
  "rental.order.done.mark-sent": "Marcado como enviado",
  "rental.order.sentByHand": "A mano, marcado por {name} · {when}",
  "rental.article.kind": "Tipo",
  "rental.article.kit": "Kit",
  "rental.article.container": "Maleta",
  "rental.article.kindHint.ITEM": "Cada unidad tiene su número de serie o etiqueta",
  "rental.article.kindHint.BULK": "Contado, no uno a uno (cables, adaptadores)",
  "rental.article.kindHint.KIT": "Se compone de otros artículos al alquilarlo (su receta); sin existencias propias",
  "rental.article.kindHint.CONTAINER": "Una maleta o un conjunto cuyas piezas contienen otros artículos (cada pieza tiene su código)",
  "rental.kit.noStock": "Un kit no tiene existencias propias: se compone de sus partes al alquilarlo.",
  "rental.item.kind": "Tipo",
  "rental.item.allKinds": "Unidades y piezas",
  "rental.item.kindPlain": "Unidades",
  "rental.item.kindPieces": "Piezas de maletas",
  "rental.item.piece": "En la pieza",
  "rental.item.device": "Dispositivo",
  "rental.recipe.title": "Receta",
  "rental.recipe.kitHint": "Lo que lleva un kit. Una línea de evento de N kits reserva N veces cada parte.",
  "rental.recipe.containerHint": "Lo que debe contener cada pieza. Una pieza con otro contenido se muestra incompleta.",
  "rental.recipe.empty": "Todavía no hay partes",
  "rental.recipe.part": "Parte",
  "rental.recipe.quantity": "Cantidad",
  "rental.recipe.add": "Añadir parte",
  "rental.recipe.removeOf": "Quitar {name} de la receta",
  "rental.recipe.saved": "Receta guardada",
  "rental.piece.title": "Piezas",
  "rental.piece.add": "Añadir pieza",
  "rental.piece.edit": "Editar pieza",
  "rental.piece.save": "Guardar pieza",
  "rental.piece.saved": "Pieza guardada",
  "rental.piece.code": "Código",
  "rental.piece.contents": "Contenido",
  "rental.piece.empty": "Todavía no hay piezas",
  "rental.piece.complete": "Completa",
  "rental.piece.incomplete": "Incompleta",
  "rental.piece.notRecipe": "No coincide con la receta:",
  "rental.piece.missing": "falta: {count} × {name}",
  "rental.piece.extra": "sobra: {count} × {name}",
  "rental.piece.nothing": "Vacía",
  "rental.piece.addItem": "Añadir una unidad",
  "rental.piece.addBulk": "Añadir a granel",
  "rental.piece.addDevice": "Añadir un dispositivo",
  "rental.piece.addOne": "Añadir",
  "rental.piece.item": "Unidad",
  "rental.piece.noItems": "No hay unidades sueltas en existencia en este almacén",
  "rental.piece.takeOut": "Sacar",
  "rental.piece.takeOutOf": "Sacar {name}",
  "rental.piece.contentsSaved": "Contenido guardado",
  "rental.device.search": "Número de serie, MAC o nombre",
  "rental.device.searchHint": "Entre los dispositivos del panel en los sitios que puede ver",
  "rental.device.none": "No se encontró ningún dispositivo",
  "rental.device.pick": "Elegir",
  "rental.device.pickOf": "Elegir {name}",
  "rental.device.inInventory": "Ya está en el inventario",
  "rental.device.takenByOther": "Vinculado a otra unidad",
  "rental.device.other": "Otro dispositivo",
  "rental.device.article": "Artículo de su unidad",
  "rental.device.articleHint": "Aún no está en el inventario: se convierte en una unidad de este artículo",
  "rental.device.hidden": "En un sitio que no puede ver",
  "rental.device.tie": "Vincular a un dispositivo",
  "rental.device.tieOf": "Vincular {name} a un dispositivo",
  "rental.device.tied": "Dispositivo vinculado",
  "rental.device.untie": "Desvincular el dispositivo",
  "rental.device.untieOf": "Desvincular el dispositivo de {name}",
  "rental.device.untieConfirm": "¿Desvincular el dispositivo de {name}? La unidad se queda en el inventario.",
  "rental.device.untied": "Dispositivo desvinculado",
  "rental.line.incomplete": { one: "{count} de las piezas libres está incompleta", other: "{count} de las piezas libres están incompletas" },
  "rental.line.perKit": "{count} por kit",
  "rental.planning.kitDay": "Un kit no tiene existencias propias: estos son los kits que sus partes permiten en el momento más bajo del día.",
  "rental.order.expectedHint": "Cuenta como esperado desde el inicio de este día",
  "rental.recipe.quantityOf": "Cantidad de {name}",
  "rental.item.kindItem": "Unidad",
  "rental.device.lastSeen": "Visto por última vez {when}",
  "rental.history.item.piece.in": "Puesto en una pieza",
  "rental.history.item.piece.out": "Sacado de una pieza",
  "rental.history.bulk.piece": "Granel en una pieza",
  "rental.history.device.tie": "Vinculado a un dispositivo",
  "rental.history.device.untie": "Dispositivo desvinculado",
  "rental.event.comment": "Comentario",
  "rental.event.commentPlaceholder": "Una nota para todos en este evento: el cliente, los planificadores, los técnicos",
  "rental.event.commentBy": "Último cambio de {name}, {when}",
  "rental.event.saveComment": "Guardar comentario",
  "rental.event.commentSaved": "Comentario guardado",
  "rental.load.title": "Carga",
  "rental.load.scan": "Escanee o escriba un código",
  "rental.load.scanHint": "Una etiqueta, código de pieza, número de serie o MAC: un escáner lo escribe y pulsa Intro",
  "rental.load.mode": "Qué hace un escaneo",
  "rental.load.modeLoad": "Cargar",
  "rental.load.modeReturn": "Devolver: {status}",
  "rental.load.loaded": "Cargado: {name}",
  "rental.load.returned": "Devuelto: {name}",
  "rental.load.failed": "No cargado",
  "rental.load.returnFailed": "No devuelto",
  "rental.load.count": "{out} de {quantity} fuera",
  "rental.load.byHand": "Añadir a mano",
  "rental.load.byHandOf": "Añadir a mano: {name}",
  "rental.load.empty": "Nada cargado aún",
  "rental.load.out": "Fuera",
  "rental.load.when": "{when} · {who}",
  "rental.load.return": "Devolver",
  "rental.load.returnOf": "Devolver {name}",
  "rental.load.part": "Pieza del kit",
  "rental.load.choose": "Artículo o pieza",
  "rental.load.none": "Nada de esto está libre en el almacén del evento",
  "rental.load.quantity": "Cantidad",
  "rental.load.load": "Cargar",
  "rental.load.missing": "Falta en la pieza (perdido)",
  "rental.load.cameBack": "Ha vuelto",
  "rental.load.cameBackHint": "De {count} fuera; el resto se anota como perdido",
  "rental.settings.archiveDays": "Conservar un sitio de evento tras cerrarlo (días)",
  "rental.settings.archiveDaysHint": "Archivado y luego eliminado tras estos días (1–3650)",
  "rental.load.cameBackOf": "{back} de {out} devueltos",
  "rental.bulk.out": "De ello en eventos",
  "rental.bulk.countedHint": "Lo que hay ahora en este almacén, también en cajas; lo que está fuera en eventos se suma",
  "rental.people.title": "Personas del cliente",
  "rental.people.hint": "Las personas de este cliente que inician sesión para ver sus eventos: las fechas, el equipo en el lugar y su estado, y el comentario",
  "rental.people.email": "Correo electrónico",
  "rental.people.name": "Nombre (opcional)",
  "rental.people.only": "Solo durante el evento",
  "rental.people.onlyHint": "El inicio de sesión solo funciona desde la salida hasta la vuelta del material de uno de sus eventos",
  "rental.people.onlyFixed": "Usted lo tiene, así que las personas que invite también lo tendrán",
  "rental.people.main": "Contacto principal",
  "rental.people.mainHint": "Puede invitar y eliminar a otras personas de este cliente",
  "rental.people.invite": "Invitar",
  "rental.people.invited": "Invitación enviada a {email}",
  "rental.people.notSent": "{email} se ha añadido, pero no se ha podido enviar el correo",
  "rental.people.none": "Nadie de este cliente tiene cuenta todavía",
  "rental.people.pending": "Invitado — aún sin contraseña",
  "rental.people.invitedBy": "Invitado por {name}, {when}",
  "rental.people.makeMain": "Nombrar contacto principal",
  "rental.people.remove": "Eliminar",
  "rental.people.removeOf": "Eliminar a {name}",
  "rental.people.removeConfirm": "¿Eliminar el acceso de {name}? Ya no podrá iniciar sesión en los eventos de este cliente.",
  "rental.people.removed": "Acceso eliminado",
  "rental.people.saved": "Guardado",
  "rental.people.failed": "No guardado",
  "rental.portal.myEvents": "Mis eventos",
  "rental.portal.people": "Personas",
  "rental.portal.nav": "Vista del cliente",
  "rental.portal.elsewhere": "Cambiar",
  "rental.portal.noEvents": "Aún no hay eventos que mostrar",
  "rental.portal.noSite": "Este evento ya no tiene sitio",
  "rental.portal.viewAsClient": "Ver como cliente",
  "rental.portal.previewBar": "Viendo como las personas de {customer} — solo lectura",
  "rental.portal.previewBarNobody": "Lo que verán las personas de {customer} cuando se las invite — solo lectura",
  "rental.portal.backToEvent": "Volver al evento",
  "rental.portal.hiddenRequested": "El cliente no ve este evento: está solicitado",
  "rental.portal.hiddenCancelled": "El cliente no ve este evento: está cancelado",
  "rental.portal.account": "Mi cuenta",
  "rental.category.nameNeeded": "Escriba primero un nombre para la categoría",
  "rental.portal.devBanner": "Este producto aún está en desarrollo activo y abierto a sus comentarios",
  "rental.item.addHow": "Cómo añadir",
  "rental.item.fromDashboard": "Desde el panel",
  "rental.item.byHand": "A mano",
  "rental.item.brand": "Marca",
  "rental.item.allBrands": "Todas las marcas",
  "rental.item.browseQ": "Nombre, número de serie o MAC",
  "rental.item.browseHint": "Basta con una parte, como RX",
  "rental.item.found": { one: "{count} dispositivo encontrado", other: "{count} dispositivos encontrados" },
  "rental.item.tooMany": "Se muestran los primeros {shown} de {total}: acote el filtro para ver el resto",
  "rental.item.selectAll": "Seleccionar todo ({count})",
  "rental.item.selectNone": "Borrar la selección",
  "rental.item.addCount": { one: "Añadir {count} unidad", other: "Añadir {count} unidades" },
  "rental.item.addedMany": { one: "{count} unidad añadida", other: "{count} unidades añadidas" },
  "rental.item.chooseDevices": "Marque primero los dispositivos que desea añadir",
  "rental.item.remove": "Quitar",
  "rental.item.removeOf": "Quitar {name}",
  "rental.item.removeConfirm": "¿Quitar {name}? Un artículo que nunca salió a un evento se elimina; uno que sí salió se da de baja y conserva su historial.",
  "rental.item.deleted": "Artículo eliminado",
  "rental.item.retiredDone": "Artículo dado de baja: se conserva su historial",
  "rental.item.showRetired": "Mostrar dados de baja",
  "rental.history.item.delete": "Artículo eliminado",
  "rental.event.remove": "Eliminar evento",
  "rental.event.removeConfirm": "¿Eliminar el evento {name}? Sus líneas, lo que salió y volvió, su sitio, los comentarios de los dispositivos y los gráficos se eliminan definitivamente. Los subalquileres para él se mantienen, sin el evento.",
  "rental.event.removed": "Evento eliminado",
  "rental.event.removeFailed": "El evento no se ha eliminado",
  "rental.event.removableFrom": "Se puede eliminar a partir del {date}",
  "rental.portal.push": "Notificación push cuando un equipo de mi evento se queda sin conexión",
  "rental.portal.pushNeedsApp": "Necesita la aplicación Velanox",
  "rental.portal.pushRefused": "No se permitieron las notificaciones push en este teléfono",
  "rental.scan.unsentConfirm": {"one": "1 escaneo no se ha enviado. ¿Cerrar sesión de todos modos? Se perderá.", "other": "{count} escaneos no se han enviado. ¿Cerrar sesión de todos modos? Se perderán."},
  "rental.scan.summaryTitle": "Escaneos enviados",
  "rental.scan.summary": "{loaded} cargados, {returned} devueltos, {refused} rechazados",
  "rental.scan.unknownCount": {"one": "1 código no correspondía a nada", "other": "{count} códigos no correspondían a nada"},
  "rental.scan.dismiss": "Cerrar",
  "rental.scan.open": "Escanear",
  "rental.scan.nfc": "NFC",
  "rental.scan.title": "Escaneo para {name}",
  "rental.scan.torch": "Linterna",
  "rental.scan.done": "Listo",
  "rental.scan.sending": "Enviando…",
  "rental.scan.waiting": "Esperando la conexión",
  "rental.scan.unknown": "no corresponde a nada",
  "rental.scan.loadedRow": "{name} · cargado",
  "rental.scan.returnedRow": "{name} · devuelto",
  "rental.scan.noCamera": "La cámara no está permitida para la app: permítala en los ajustes del teléfono",
  "rental.scan.hint": "Mantenga los códigos a la vista",
  "rental.scan.hintNfc": "Mantenga los códigos a la vista, o acerque una etiqueta al teléfono",
  "rental.scan.nfcPrompt": "Acerque una etiqueta a la parte superior del iPhone",
  "rental.tag.of": "Etiqueta de {name}",
  "rental.tag.save": "Guardar etiqueta",
  "rental.tag.hold": "Acerque la etiqueta al teléfono",
  "rental.tag.writeFailed": "No se pudo escribir la etiqueta: manténgala quieta e inténtelo de nuevo",
  "rental.tag.scanTitle": "Escanear una etiqueta",
  "rental.tag.scanHint": "Mantenga el código de la etiqueta a la vista",
  "rental.tag.none": "Ningún artículo tiene esta etiqueta",
  "rental.tag.looking": "Buscando la etiqueta…",
  "rental.scan.sameItem": "mismo artículo, ya contado",
  "rental.scan.unsentConfirmServer": {"one": "1 escaneo no se ha enviado. ¿Elegir otro servidor de todos modos? Se perderá.", "other": "{count} escaneos no se han enviado. ¿Elegir otro servidor de todos modos? Se perderán."},
  "rental.people.clientExport": "Los clientes pueden exportar",
  "rental.people.clientExportHint": "Las personas del cliente pueden descargar este evento desde su página: sus dispositivos con sus notas, sus gráficos y la lista de personas",
  "rental.people.exportOn": "Los clientes pueden exportar este evento",
  "rental.people.exportOff": "Los clientes ya no pueden exportar este evento",
  "rental.planning.exportNote": "libre por día; un número negativo es lo que falta",
  "rental.portal.readOnly": "Solo lectura — lo que informa este equipo",
  "rental.portal.deviceGone": "Este dispositivo ya no está en su evento",
  "rental.portal.noStored": "Todavía no se ha guardado nada de este dispositivo",
  "rental.portal.sinceLoaded": "Desde {when}, cuando salió para este evento",
  "rental.portal.unnamedLink": "Enlace sin nombre",
  "rental.portal.range1h": "1 h",
  "rental.portal.range6h": "6 h",
  "rental.portal.cellular": "Red móvil",
  "rental.portal.poe": "PoE",
  "rental.portal.standby": "En espera",
  "rental.portal.unnamedDevice": "Dispositivo sin nombre",
  "rental.pings.title": "Dispositivos con ping",
  "rental.pings.portalTitle": "Sus dispositivos",
  "rental.pings.intro": "Se comprueban con ping en su dirección IP a través de las radios MikroTik de su evento mientras está en curso.",
  "rental.pings.companyIntro": "Los dispositivos del cliente, comprobados con ping en su dirección IP a través de las radios MikroTik del evento en curso del cliente — solo la red de ese evento.",
  "rental.pings.name": "Nombre",
  "rental.pings.ip": "Dirección IP",
  "rental.pings.state": "Estado",
  "rental.pings.rtt": "Tiempo de respuesta",
  "rental.pings.answered": "Última respuesta",
  "rental.pings.foundThrough": "Encontrado a través de",
  "rental.pings.status.ONLINE": "En línea",
  "rental.pings.status.OFFLINE": "Sin conexión",
  "rental.pings.status.NO_ANSWER": "Sin respuesta",
  "rental.pings.status.UNKNOWN": "Sin comprobar",
  "rental.pings.add": "Añadir dispositivo",
  "rental.pings.edit": "Editar",
  "rental.pings.save": "Guardar",
  "rental.pings.remove": "Eliminar",
  "rental.pings.removeConfirm": "¿Quitar {name} de los dispositivos con ping?",
  "rental.pings.pingNow": "Hacer ping manualmente",
  "rental.pings.pingAll": "Hacer ping a todos",
  "rental.pings.none": "Todavía no hay dispositivos",
  "rental.pings.mode": "Comprobaciones de ping",
  "rental.pings.mode.EVERY_30S": "Cada 30 segundos",
  "rental.pings.mode.EVERY_MINUTE": "Cada minuto",
  "rental.pings.mode.EVERY_5_MINUTES": "Cada 5 minutos",
  "rental.pings.mode.ON_OPEN": "Solo cuando abro el panel",
  "rental.pings.mode.OFF": "Desactivado",
  "rental.pings.changedBy": "Cambiado por {name}, {when}",
  "rental.pings.onOpenLine": "Se comprueba solo mientras esta página está abierta (como máximo cada 5 minutos)",
  "rental.pings.notOn": "Ahora sin comprobar: ninguno de los eventos del cliente está en curso",
  "rental.pings.answering": "{count} de {total} responden",
  "rental.pings.failed": "No ha funcionado",
  "rental.portal.pushPings": "Notificación cuando mis dispositivos dejen de responder",
  "rental.pings.notOnClient": "Ahora sin comprobar: ninguno de sus eventos está en curso",
  "rental.pings.appliesNow": "Ahora se comprueba como {mode}: la configuración más frecuente de sus eventos en curso",
  "rental.event.openSite": "Abrir el sitio",
}

export default rental
